<mat-form-field class="form-field" *ngIf="!entity">
  <mat-label *ngIf="field.label">{{field.label}}</mat-label>
  <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" (keyup.enter)="keyPress($event)"
    (focus)="selectOnFocus($event)" [ngStyle]="field.inputStyles" [formControl]="entityControl"
    [placeholder]="field.label" [required]="field.required" autocomplete="off">
  <mat-icon class="pointer" matSuffix (click)="searchEntity()">search</mat-icon>
</mat-form-field>

<div *ngIf="entity" [ngClass]="field.entityRowStyles" class="entity-row">
  <mat-label *ngIf="field.label" class="entity-label" [ngStyle]="field.entityRowLabelStyles">{{field.label}}</mat-label>
  <div class="entity-name" [ngStyle]="field.entityNameGroupStyles">
    <span [ngStyle]="field.entityNameStyles">
      {{selectedName}}
    </span>
    <mat-icon class="pointer" [ngStyle]="field.clearEntityStyles" *ngIf="isEnabledFn(field.name, field.id)"
      (click)="setEntity(null)">clear</mat-icon>
  </div>
</div>
